module.exports = __webpack_public_path__ + "static/media/delivery-disabled.a241ca5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/delivery-disabled.svg
// module id = 2256
// module chunks = 0